export default "__VITE_ASSET__Bv_dPcG3__"